import { useIsUserGuideViewable } from './is_user_guide_viewable'
import { useToggleUserGuide } from './use-toggle-user-guide'

export const useIsUserGuideExpanded = () => {
  const userGuideViewable = useIsUserGuideViewable()
  const [isGettingStartGuideOpen] = useToggleUserGuide()

  return userGuideViewable && isGettingStartGuideOpen
}
